module.exports = __webpack_public_path__ + "static/img/viviap_logo.921ba5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/viviap_logo.png
// module id = mOCd
// module chunks = 0